import { Payout } from 'services/api/entities';

export const getPayoutAmount = ({
  cents,
  currency,
}: Pick<Payout, 'cents' | 'currency'>) =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency,
  });

export default getPayoutAmount;
